import React, { useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';

interface Props {
    src: string; // ベースのURL（tokenパラメータなし）
}

export const SecureIframe: React.FC<Props> = ({ src }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const baseUrl = process.env.REACT_APP_RESERVE_BASE_URL!;
    const allowOrigin = useMemo(() => {
        try {
            return new URL(baseUrl).origin;
        } catch (e) {
            return "https://bespo-staging.blocks-app.com https://bespo-prod.blocks-app.com";
        }
    }, [baseUrl]);

    const token = sessionStorage.getItem('tableRequestApiKey');

    // ✅ token付きURL生成（tokenをURLパラメータとして付ける）
    const srcWithToken = useMemo(() => {
        if (!token) return src;
        const url = new URL(src, baseUrl);
        url.searchParams.set('token', token);
        return url.toString();
    }, [src, token, baseUrl]);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (iframe && token && restaurantId) {
            const tokenData = {
                token,
                restaurant_id: restaurantId,
                iss: "Blocks",
                exp: 86400,
            };

            iframe.onload = () => {
                iframe.contentWindow?.postMessage(tokenData, new URL(baseUrl).origin);
            };
        }
    }, [restaurantId, token, baseUrl]);

    return (
        <iframe
            ref={iframeRef}
            title={`secure-iframe-${restaurantId || 'unknown'}`}
            sandbox="allow-storage-access-by-user-activation
            allow-scripts allow-same-origin allow-forms allow-popups allow-downloads allow-modals"
            allow={`clipboard-write ${allowOrigin}`}
            style={{ width: "100%", height: "100vh" }}
            frameBorder="0"
            src={srcWithToken} // ← URLにtokenを含める
        />
    );
};